<mat-toolbar color="primary" class="header">
  <div class="left">
    <img 
      src="assets/ibew-logo-250.png" 
      alt="IBEW logo" 
      class="header-logo"
    />
    <a routerLink="" class="title">IBEW Vote Scorecard</a>
  </div>

  <p class="tagline">
    How your legislators voted on key IBEW bills.
  </p>

  <div class="app-version" [matTooltip]="appversion">
    <mat-icon class="info-icon">info_outline</mat-icon>
  </div>
</mat-toolbar>

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}